$(function(){
    // 目次クリック
    $('.indexArea_fixed a').click(function () {
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        console.log($(target).offset().top)
        //   ヘッダー分下げる
        scroll = $(window).scrollTop();
        if (scroll >= headerH){
            var pos = Math.round($(target).offset().top-60);
        }else{
            var pos = Math.round($(target).offset().top-110);
        }
        $('body,html').animate({scrollTop: pos}, 500);
        return false;
    });
    $('.indexArea a').click(function () {
        var speed = 500;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $("html, body").animate({scrollTop:position}, speed, 'swing');
    });

    // 目次の上部固定
    var headerH = $('.indexArea_fixed').offset().top;
    var scroll = $(window).scrollTop();
    function FixedAnime() {
        scroll = $(window).scrollTop();
        if (scroll >= headerH){
            $('.indexArea_fixed').addClass('fixed');
            $('.hidden_indexArea').addClass('show');
        }else{
            $('.indexArea_fixed').removeClass('fixed');
            $('.hidden_indexArea').removeClass('show');
        }
    }
    $(window).scroll(function () {
        FixedAnime();
    });

    $(window).on('load', function () {
        FixedAnime();
    });

})